import React, {type ReactElement} from "react";

export default function IssueClosedMark (): ReactElement {
    return <div className={'d-flex justify-content-center'}>
        <div className={'badge bg-white color-black padding-1 fs-6'}>
            Support request resolved
        </div>
    </div>
}
